import { RootState } from '../..';
import { useSelector } from 'react-redux';
import { AppModalState } from '.';

export const useModalState = (): Partial<AppModalState> =>
  useSelector((state: RootState) => state.ModalAction);
